// hooks/useClientStats.ts
import { useEffect, useMemo } from "react";
import { useClientsSupabaseStore } from "@/store/api/clientsSupabaseStore";
import { computeClientKpis, prepareClientList } from "@/utils/clientStats";
import { Client } from "@/types/types";
import { useUserStore } from "@/store/userStore";

export function useClientStats() {
  const clientsStore = useClientsSupabaseStore();
  const { gymId } = useUserStore();

  useEffect(() => {
    if (gymId) {
      clientsStore.fetchClients();
    }
  }, [gymId, clientsStore.fetchClients]);

  const clients: Client[] = useMemo(() => prepareClientList(clientsStore.clients), [clientsStore.clients]);

  const kpis = useMemo(() => computeClientKpis(clients), [clients]);


  return { clients, kpis, isLoading: clientsStore.isLoading };
}
